import React, {
  createContext,
  Dispatch as DispatchType,
  FC,
  useReducer
} from 'react'
import { Action } from 'typesafe-actions'
import {
  defaultConsumption,
  ConsumptionState,
  reducer
} from 'stores/consumption'

/**
 * The consumption state context – used when accessing the data using the
 * `useContext` hook.
 *
 * For the provider, use {@link ConsumptionProvider} instead of the default
 * `.Provider`.
 */
export const Consumption = createContext<ConsumptionState>(defaultConsumption)

/**
 * The Dispatch provider – when you need to access the dispatch of the reducer.
 */
export const Dispatch = createContext<DispatchType<Action>>(() => {})

/**
 * Provides the Consumption context, and connects it to the reducer.
 */
export const ConsumptionProvider: FC<{}> = ({ children }) => {
  const [consumptionState, dispatch] = useReducer(reducer, defaultConsumption)
  return (
    <Consumption.Provider value={consumptionState}>
      <Dispatch.Provider value={dispatch}>{children}</Dispatch.Provider>
    </Consumption.Provider>
  )
}
